import { Component, OnInit, ViewChild } from '@angular/core';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { BonusService } from 'src/app/services/bonus/bonus.service';
import { EventsService } from 'src/app/services/event/event.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Navigator } from "src/app/services/routing/navigator";
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { IonContent } from '@ionic/angular';
import { GlobalErrorHandlerService } from 'src/app/services/global-errors/global-error-handler.service';

@Component({
  selector: 'app-bonus-offers',
  templateUrl: './bonus-offers.component.html',
  styleUrls: ['./bonus-offers.component.scss'],
})

export class BonusOffersComponent implements OnInit {

  @ViewChild(IonContent, { static: false }) content: IonContent;

  public bonusObj: any[] = [];
  public offers: any[] = [];
  public error: GlobalErrorHandlerService = null;
  public showNoBonusText: boolean = false;

  removeAnouncments = item => !item.campaign_type?.includes("ANNOUNCEMENT") && (!item.campaign_code?.includes("ZZ_NO_DEPOSIT") && !item.campaign_code?.includes("ZZ_NO_WELCOME"));

  constructor(
    public appLinks: AppLinksService,
    public cashierContentService: CashierContentService,
    public bonusService: BonusService,
    public events: EventsService,
    public navigator: Navigator,
    public utils: UtilsService,
  ){
    this.onGetBonusOffers();
  }

  ngOnInit(): void {
  }

  onGetBonusOffers() {
    this.bonusService.callGetBonusOffers().subscribe((response: any) => {
        if (response && !!response.result) {
          let data = response.payload;
          this.offers = data.filter(this.removeAnouncments);
          //Filter out the loyalty draw entries
          this.offers = this.offers.filter(offer => !(offer.campaign_type === 'DRAW' && offer.offer_type === 'LOYALTY_DRAW_ENTRY'));
    
          //Exclude the already opt-in bonuses to get the Available Bonus list
          let availableBonusArray = this.offers.filter(x => !x.opt_in)
          let activeBonusArray = this.offers.filter(x => x.opt_in == true)
          this.events.publish("event:Totalbonus", { activeBonus: activeBonusArray, page: 'Bonus Offers', availableBonus: availableBonusArray });
          if(this.offers.length > 0) this.showNoBonusText = true;
        } else{
          this.showNoBonusText = false;
        }
      },(error) => {
        this.showNoBonusText = false;
        this.error = error;
        this.content.scrollToTop(10);
      }
    );
  }

  onCouponClicked(offer) {
    this.events.publish("event:BonusOffer", { bonusOffer: offer, actionType: 'clickthrough' });
    return this.navigator.navigateTo("RedeemBonusCodeComponent", { multipleModals: true }, { bonusCode: offer.campaign_code });
  }

  public openExternalLinks(url, title): any{
    return this.appLinks.openPopover(url, title)
  }

  public onCouponDepositClicked(offer): any {
    this.cashierContentService.updateBonusOfferValue(offer.campaign_code);
    return this.events.publish("event:BonusOffer", { bonusOffer: offer, actionType: 'clickthrough' });
  }

  public onCouponReferFriendClicked(offer): any {
    return this.events.publish("event:ReferFriend", { bonusOffer: offer, actionType: 'clickthrough' });
  }

  //Passing whole object insted bonus ID so, Tealim gets the full information when user accepts the Bonus
  onOptInClicked(event, offer) {
    event.target.disabled = true;

    this.bonusService.callBonusOfferOptIn(offer.id).subscribe((response: any) => {
        if (response && !!response.result) {
          //Tealium event when user accepts the offer
          this.events.publish("event:BonusOffer", { bonusOffer: offer, actionType: 'accepted' });
          this.onGetBonusOffers();
        }
      }, (error) => {
          this.content.scrollToTop(10);
          this.error = error;
      }
    );
  }
}
